import * as React from 'react';
import styles from './alert-info.scss';

export interface AlertInfoProps {
  text: string;
  children?: React.ReactNode;
}

export const AlertInfo = ({ text, children = null }: AlertInfoProps) =>
  <div className="col-md-12">
    <div className={styles.alertInfo}>
      {text ? <p>{text}</p> : null}
      {children}
    </div>
  </div>;
